import gql from 'graphql-tag';

export const QUERY_ALL_ARTICLES = gql`
  query articles($status: ArticleStatus, $type: ArticleType) {
    articles(status: $status, type: $type) {
      booking {
        id
        image
        title
        status
        textarea
      }
      payment {
        id
        image
        title
        status
        textarea
      }
      property {
        id
        image
        title
        status
        textarea
      }
    }
  }
`;

export const DELETE_ARTICLE = gql`
  mutation deleteArticle($input: DeletedArticleInput!) {
    deleteArticle(input: $input) {
      success
    }
  }
`;

export const UPDATE_ARTICLE_POSITION = gql`
  mutation updateArticlePosition($input: UpdateArticlesPositionInput!) {
    updateArticlePosition(input: $input) {
      success
    }
  }
`;
